import laroute from '@laroute';

const getInitialState = () => ({
	isLoading:           false,
	follows:             [],
	followables:         [],
	followInProgressFor: [],
});

export const mutations = {
	SET_FOLLOWS:                'setFollows',
	SET_IS_LOADING:             'setIsLoading',
	SET_FOLLOWABLES:            'setFollowables',
	SET_FOLLOW_IN_PROGRESS_FOR: 'setFollowInProgressFor',
};

export const actions = {
	LOAD_FOLLOWS:     'loadFollows',
	LOAD_FOLLOWABLES: 'loadFollowables',
	FOLLOW:           'follow',
	UNFOLLOW:         'unfollow',
};

export default {
	namespaced: true,
	state:      getInitialState,
	mutations:  {
		[mutations.SET_FOLLOWS](state, follows) {
			state.follows = follows;
		},
		[mutations.SET_IS_LOADING](state, isLoading) {
			state.isLoading = isLoading;
		},
		[mutations.SET_FOLLOWABLES](state, followables) {
			state.followables = followables;
		},
		[mutations.SET_FOLLOW_IN_PROGRESS_FOR](state, followInProgressFor) {
			state.followInProgressFor = followInProgressFor;
		},
	},
	actions: {
		async [actions.LOAD_FOLLOWS]({ commit }) {
			try {
				commit(mutations.SET_IS_LOADING, true);
				const response = await fetch(laroute.route('arena.api.follows.get'));
				const data = await response.json();
				commit(mutations.SET_FOLLOWS, data);
			} catch (error) {
				console.error(error);
			} finally {
				commit(mutations.SET_IS_LOADING, false);
			}
		},
		async [actions.LOAD_FOLLOWABLES]({ commit }) {
			const response = await fetch(laroute.route('arena.api.follows.related'));
			const data = await response.json();
			const followables = (data || []).map((item) => {
				return {
					context: {
						id:   item.contextId,
						name: item.contextName,
					},
					contextable: {
						id:       item.contextableId,
						imageUrl: item.imageUrl,
						name:     item.name,
					},
				};
			});
			commit(mutations.SET_FOLLOWABLES, followables);
		},
		async [actions.FOLLOW]({ state, commit }, item) {
			try {
				commit(mutations.SET_FOLLOW_IN_PROGRESS_FOR, [...state.followInProgressFor, item]);
				await fetch(laroute.route('arena.api.follows.add', {
					contextId:     item.context.id,
					contextableId: item.contextable.id,
				}), {
					method: 'PUT',
				});
				commit(mutations.SET_FOLLOWS, [...state.follows, item]);
				commit(mutations.SET_FOLLOW_IN_PROGRESS_FOR, state.followInProgressFor.filter((currentItem) => !(currentItem.context.id === item.context.id && currentItem.contextable.id === item.contextable.id)));
			} catch (error) {
				console.error(error);
			}
		},
		async [actions.UNFOLLOW]({ state, commit }, item) {
			try {
				commit(mutations.SET_FOLLOW_IN_PROGRESS_FOR, [...state.followInProgressFor, item]);
				await fetch(laroute.route('arena.api.follows.delete', {
					contextId:     item.context.id,
					contextableId: item.contextable.id,
				}), {
					method: 'DELETE',
				});
				commit(mutations.SET_FOLLOWS, state.follows.filter((currentItem) => !(currentItem.context.id === item.context.id && currentItem.contextable.id === item.contextable.id)));
				commit(mutations.SET_FOLLOW_IN_PROGRESS_FOR, state.followInProgressFor.filter((currentItem) => !(currentItem.context.id === item.context.id && currentItem.contextable.id === item.contextable.id)));
			} catch (error) {
				console.error(error);
			}
		},
	},
	getters: {
		follows:             state => state.follows,
		isLoading:           state => state.isLoading,
		followables:         state => state.followables,
		followInProgressFor: state => state.followInProgressFor,
	},
};
